import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusState } from "store/types";
import { fetchUserPosts } from "./userPosts.actions";
import { PostToSelect, UserPostsState } from "./userPosts.types";

const initialState: UserPostsState = {
  data: [],
  status: StatusState.IDLE,
  error: null
};

const userPostsSlice = createSlice({
  name: "userPosts",
  initialState,
  reducers: {
    setUserPosts: (state, action: PayloadAction<PostToSelect[]>) => {
      state.data = action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserPosts.fulfilled, (state) => {
        state.status = StatusState.SUCCEEDED;
        state.error = null;
      })
      .addCase(fetchUserPosts.pending, (state) => {
        state.status = StatusState.LOADING;
        state.error = null;
      })
      .addCase(fetchUserPosts.rejected, (state, action) => {
        state.status = StatusState.FAILED;
        state.error = action.payload as string;
      });
  },
});

export const { setUserPosts } = userPostsSlice.actions;
const userPostsReducer = userPostsSlice.reducer;
export default userPostsReducer;
